import { render } from "./BenefitsSection.vue?vue&type=template&id=08b912eb&scoped=true"
import script from "./BenefitsSection.vue?vue&type=script&lang=js"
export * from "./BenefitsSection.vue?vue&type=script&lang=js"

import "./BenefitsSection.vue?vue&type=style&index=0&id=08b912eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b912eb"]])

export default __exports__